import { BasicScene } from "$/game/prefabs/scenes/BasicScene.ts";
import { DecorRoomItem } from "$/game/prefabs/DecorRoomItem.ts";

export class CarpetDecorObject extends DecorRoomItem {
  constructor(scene: BasicScene, x: number, y: number) {
    super(scene, x, y, scene.atlas, scene.keys.assets.sprites.decor.carpet);
  }
}
